import Img from "components/common/List/img";
import Text from "components/common/List/Text";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";
import InterestStar from "../../components/InterestStar";
import DividerButton from "components/common/divider/button";
import { useHighStrategyAssets } from "utils/clientAPIs/stragey";
import { HighTotalScoreSkeleton } from "components/skeleton/KB";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
import { KOREA } from "utils/constant/ITME_INFO";
import { trackPageAction } from "lib/analytics/core/actions";
import { ERROR_LOGO_URL, getPublicAssetUrl } from "utils/objectStorage";

function StrateRanking({}: {}) {
  const router = useRouter();
  const { t } = useTranslation("main");
  const [list, BASE_DT, loading, error] = useHighStrategyAssets();
  const [page, setPage] = useState(0);
  const [sliceData, setSliceData] = useState<any>([]);
  useEffect(() => {
    if (list) {
      setSliceData(list.slice(0, 3));
    }
  }, [list]);
  const handleNext = () => {
    trackPageAction("more_kb_strat_more");
    if (list) {
      if (page < 2) {
        setPage(page + 1);
        setSliceData(list.slice((page + 1) * 3, (page + 2) * 3));
      } else {
        setPage(0);
        setSliceData(list.slice(0, 3));
      }
    }
  };
  const ListTemp = ({ asset, index }: { asset: any; index: number }) => {
    return (
      <TrackedListItem
        itemData={{
          kind: "stock",
          ticker: asset.ITEM_CD_DL,
          market: asset?.LOC === KOREA ? "kr" : "us",
          rank: index + 1,
        }}
        href={`/detail/${asset.ITEM_CD_DL}`}
        className={` w-full flex items-center  px-6 py-2  gap-3 bg-white `}
        data-gtm-id={`kb-strategy-list`}
      >
        <div className="justify-center items-center inline-flex">
          <span
            className={` text-center text-blue40  text-[15px] font-semibold leading-none whitespace-nowrap`}
          >
            {index + 1}
          </span>
        </div>
        <Img
          src={
            getPublicAssetUrl(`logos/${asset.ITEM_CD_DL}.png`) ||
            ERROR_LOGO_URL
          }
          HR_ITEM_NM={""}
        />

        <div
          className={`justify-start grow  overflow-hidden whitespace-pre-wrap flex-col  items-start inline-flex `}
        >
          <Text
            item={
              router.locale === "ko"
                ? asset.ITEM_KR_NM && asset.ITEM_KR_NM
                : asset.ITEM_ENG_NM && asset.ITEM_ENG_NM
            }
            price={t("thisMonth")}
            percent={asset.ADJ_CLOSE_CHG.toLocaleString("en-us", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
          />
        </div>

        <div className="flex items-center shrink-0 justify-end">
          <div>
            {
              <InterestStar
                asset={asset}
                size={30}
                triggerSectionId="kb_monthly_strategy_picks"
              />
            }
          </div>
        </div>
      </TrackedListItem>
    );
  };

  if (loading || error || sliceData?.length === 0)
    return (
      <div>
        <HighTotalScoreSkeleton />
      </div>
    );

  const date = BASE_DT
    ? t("yearMonth", {
        year: BASE_DT?.split("-")?.[0].slice(-2),
        month: Number(BASE_DT?.split("-")?.[1]),
      })
    : "";
  return (
    <div className="flex flex-col w-full gap-2">
      <div className="px-6 pt-6 flex flex-col gap-1">
        <span className={`${TYPO.TYPO8_RG} text-gray60`}>{date}</span>
        <span className={`${TYPO.TYPO4_SB} text-gray80`}>
          {t("monthlyAiPicks")}
        </span>
      </div>
      <TrackedList
        listId="kb_monthly_strategy_picks"
        totalCount={sliceData?.length}
      >
        <div className="py-2 flex flex-col gap-2">
          {sliceData?.map((asset: any, index: number) => {
            return (
              <ListTemp asset={asset} key={index} index={index + 3 * page} />
            );
          })}
        </div>
      </TrackedList>

      <DividerButton
        text={t("viewMorePage", { page: page + 1, total: 3 })}
        onClick={handleNext}
        data-gtm-id={`kb-strategy-more-button`}
      />
    </div>
  );
}

export default StrateRanking;
